import { Component } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { SiteFooterComponent } from '../site-footer/site-footer.component';
import { START_STORY_URL } from '../site-links';

@Component({
  selector: 'app-site-layout',
  standalone: true,
  imports: [RouterOutlet, RouterLink, SiteFooterComponent],
  host: { class: 'site block min-h-screen' },
  template: `
    <router-outlet />
    <app-site-footer />
    <div
      class="fixed inset-x-0 bottom-0 z-40 border-t border-ink/10 bg-snow/95 p-3 backdrop-blur md:hidden"
    >
      <a [routerLink]="startStoryUrl" class="cta w-full">START THEIR SANTA STORY</a>
    </div>
  `,
})
export class SiteLayoutComponent {
  readonly startStoryUrl = START_STORY_URL;
}
